import React, { useState, useContext, useEffect } from "react"

import { AuthContext } from "@meddbriefer/mdb-auth"

const defaultPrefs = {
    patientStatusDisplay: "leftColumn"
}


export const PreferencesContext = React.createContext({})


export const PreferencesProvider = (props) => {
    const { isAuthenticated, getUserData, saveUserData, setUserPrefs } = useContext(AuthContext)
    const [showPrefsForm, setShowPrefsForm] = useState(false)
    const [ patientStatusDisplay, setPatientStatusDisplay ] = useState(defaultPrefs.patientStatusDisplay)
    // const [intvListStyle, setIntvListStyle] = useState(defaultPrefs.intvListStyle)
    // const [headToToeStyle, setHeadToToeStyle] = useState(defaultPrefs.headToToeStyle)

    const setPref = (name, value) => {
        switch(name) {
            case "patientStatusDisplay":
                setPatientStatusDisplay(value)
                break
            // case "intvListStyle":
            //     setIntvListStyle(value)
            //     break
            // case "headToToeStyle":
            //     setHeadToToeStyle(value)
            //     break
            default:
                console.log(`not setting unknown pref ${name} to ${value}`)
        }
    }

    const displayPrefsForm = () => {
        // console.log("displayPrefsForm")
        setShowPrefsForm(true)
    }
    const hidePrefsForm = () => {
        // console.log("hidePrefsForm")
        setShowPrefsForm(false)
    }

    // On logged-in useEffect
    // useEffect(() => {
    //     // Get user data and apply if logged in
    //     isAuthenticated &&
    //     getUserData()
    //         .then(res => {
    //             // console.log(res);
    //             setCurrentLayout(res.preferences.layout);
    //         })
    //         .catch(err => console.log(err));
    // }, [isAuthenticated]);

    // Pass preferences to auth for DB sync
    useEffect(() => {
        // Preferences data to upload
        let data = {
            patientStatusDisplay
        }

        // Update preferences and save if logged in
        setUserPrefs({data})
        isAuthenticated && saveUserData("preferences", data)

    }, [patientStatusDisplay]);


    return (
        <PreferencesContext.Provider
            value={{
                // intvListStyle,
                // headToToeStyle,
                setPref,
                showPrefsForm,
                displayPrefsForm,
                hidePrefsForm,
                patientStatusDisplay,
            }}
        >
            {props.children}
        </PreferencesContext.Provider>
    )
}

export const usePrefs = () => useContext(PreferencesContext)
